import React from 'react';
import { Carousel, Spin } from 'antd';
import { ImageLoadingObject } from '@common-types';
import { IChain, IImage } from '@share/common-types';

import './style.scss';
import { NOT_IMAGE_PROPERTY } from '@constants';

interface IProps {
  images: IImage[];

  keyValue?: string;

  isNoCoverFit?: boolean;

  chain?: IChain | boolean;
}

interface IState {
  imagesMap: ImageLoadingObject;
}

const speed = 500;
const slidesToShow = 1;
const slidesToScroll = 1;

export class CarouselImages extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      imagesMap: this.generateImagesMap(),
    };
  }

  generateImagesMap = (): ImageLoadingObject => {
    return this.props.images.reduce((res: ImageLoadingObject, img: IImage, index: number) => {
      res[index] = {
        img,
        loading: true,
      };

      return res;
    }, {} as ImageLoadingObject);
  };

  componentDidUpdate(prevProps: Readonly<IProps>): void {
    if (prevProps.images !== this.props.images) {
      this.setState({ imagesMap: this.generateImagesMap() });
    }
  }

  onImageLoad = (index: number): void => {
    this.setState((prevState: IState) => {
      return {
        ...prevState,
        imagesMap: {
          ...prevState.imagesMap,
          [index]: {
            ...prevState.imagesMap[index],
            loading: false,
          },
        },
      };
    });
  };

  hasNotRealImageProperty = (): boolean => {
    const { images } = this.props;
    return !!(images?.some(img => img.url?.toLowerCase().includes(NOT_IMAGE_PROPERTY)));
  };

  render(): React.ReactNode {
    const propsCarousel = {
      dots: false,
      infinite: true,
      arrows: true,
      speed,
      slidesToShow,
      slidesToScroll,
    };
    const { images, isNoCoverFit, keyValue, chain } = this.props;
    const { imagesMap } = this.state;

    // Check if chain is an object with a thumb property
    const chainThumb = chain && typeof chain !== 'boolean' && chain.thumb ? chain.thumb : null;
    const chainName = chain && typeof chain !== 'boolean' && chain.name ? chain.name : '';

    const notRealImageProperty = this.hasNotRealImageProperty();
    const styleImg: any = {};
    if (notRealImageProperty) {
      styleImg.filter = 'grayscale(100%)';
    }

    return (
      <Carousel {...propsCarousel} lazyLoad="ondemand">
        {images.map((image: IImage, i: number) => {
          return (
            <div className="custom-carousel-image" key={i}>
              <div className="custom-carousel-image__spinner" style={{ height: 'inherit' }}>
                <Spin />
              </div>
              <img
                style={{ display: imagesMap[i]?.loading ? 'none' : 'block', ...styleImg }}
                key={`carrousel_image${keyValue ? `_${keyValue}` : ''}_${i}`}
                className={`custom-carousel-image__item ${isNoCoverFit ? 'no-cover' : ''}`}
                src={image.url}
                alt={image.description}
                onLoad={() => this.onImageLoad(i)}
              />
              {chainThumb && !imagesMap[i]?.loading && (
                <img
                  src={chainThumb}
                  alt={"Chain " + chainName}
                  className="custom-carousel-image__chain-logo"
                />
              )}
            </div>
          );
        })}
      </Carousel>
    );
  }
}